import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { TextArea } from 'dibs-elements/exports/TextArea';
import { Button } from 'dibs-elements/exports/Button';

// Helpers
import actions from '../../actions/FavoritesActions';
import { copy, cutoffs, modals, mutations } from '../../constants';

// Styles
import styles from './styles/AddNoteModal.scss';

class AddNoteModal extends React.Component {
    constructor(props) {
        super(props);

        this.savedNote = this.props.note;
        this.deleteNote = this.deleteNote.bind(this);
        this.editNote = this.editNote.bind(this);
    }

    deleteNote() {
        this.props.setOpenModalType(modals.DELETE_NOTE);
        this.props.onClick({
            action: mutations.types.EDIT,
            note: '',
        });
    }

    editNote() {
        this.props.onClick({
            action: mutations.types.EDIT,
            note: this.props.note,
        });
    }

    render() {
        const { isPublic } = this.props;
        return (
            <ModalContainer
                dataTn="add-note"
                onClose={this.props.closeModal}
                isOpen={this.props.modalOpen}
                modalPosition="center"
            >
                <ModalCloseButton onClick={this.props.closeModal} />
                <BarHeader dataTn="add-note" title={this.props.title} />
                <ModalBody dataTn="add-note">
                    <div className={styles.item}>
                        <div className={styles.box}>
                            <img
                                data-tn="add-note-modal-thumbnail"
                                className={styles.image}
                                src={this.props.noteImage}
                            />
                        </div>
                        <div data-tn="add-note-modal-title" className={styles.itemTitle}>
                            {this.props.noteTitle}
                        </div>
                    </div>
                    <div className={styles.textArea}>
                        <TextArea
                            maxLength={cutoffs.MAX_CHAR_NOTE}
                            dataTn="add-note-modal-textarea"
                            onChange={e => this.props.setNote(e.target.value)}
                            placeholder={copy.addNote.PLACEHOLDER_NOTE}
                            showCount={!isPublic}
                            showBorder={!isPublic}
                            value={this.props.note}
                        />
                    </div>
                    {isPublic ? null : (
                        <div className={styles.submit}>
                            <Button
                                dataTn="add-note-modal-submit"
                                onClick={this.editNote}
                                disabled={this.props.note === ''}
                                fullWidth
                                size="large"
                            >
                                {copy.addNote.SUBMIT}
                            </Button>
                        </div>
                    )}
                    {this.savedNote !== '' && !isPublic ? (
                        <div className={styles.deleteNote}>
                            <span
                                className={styles.deleteText}
                                onClick={this.deleteNote}
                                data-tn="delete-note"
                            >
                                {copy.deleteNote.DELETE}
                            </span>
                        </div>
                    ) : null}
                </ModalBody>
            </ModalContainer>
        );
    }
}

AddNoteModal.defaultProps = {
    isPublic: false,
};

AddNoteModal.propTypes = {
    closeModal: PropTypes.func,
    mutationResponse: PropTypes.string,
    note: PropTypes.string,
    noteImage: PropTypes.string,
    noteTitle: PropTypes.string,
    modalOpen: PropTypes.bool,
    openModalType: PropTypes.string,
    onClick: PropTypes.func,
    setNote: PropTypes.func,
    setOpenModalType: PropTypes.func,
    title: PropTypes.string,
    type: PropTypes.oneOf(['folder', 'items']),
    isPublic: PropTypes.bool,
};

const mapStateToProps = state => {
    return {
        note: state.favorites.creationState.note,
        noteImage: state.favorites.creationState.noteImage,
        noteTitle: state.favorites.creationState.noteTitle,
        mutationResponse: state.favorites.uiState.mutationResponse,
        openModalType: state.favorites.modalState.openModalType,
        selectedItem: state.favorites.uiState.selectedItems[0],
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setOpenModalType: openModalType => {
            dispatch(actions.setOpenModalType({ openModalType }));
        },
        setNote: note => {
            dispatch(actions.setNote({ note }));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddNoteModal);
